const menu = [
  { href: '/legal/terms', label: 'Terms of Service' },
  { href: '/legal/privacy', label: 'Privacy & Cookie Statement' },
  { href: '/legal/cookies', label: 'Cookie Policy' },
  { href: '/legal/takedown', label: 'Notice and Takedown Policy' },
  { href: '/legal/disclosure', label: 'Responsible Disclosure Policy' },
  { href: '/legal/advertising', label: 'Advertising Terms &\xa0Conditions' },
];

export default menu;
